<!-- eslint-disable max-len -->
<template>
  <div>
    <b-row>
      <b-col md="8">
        <h4>IDENTITAS PENDIDIK DAN TENAGA KEPENDIDIKAN</h4>
        <b-row>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.kode_pegawai.$error}">
              <label> Kode Pegawai </label>
              <j-input
                v-model="$v.data_master.kode_pegawai.$model"
                :disabled="readOnly"
                placeholder="Kode Pegawai"/>
            </b-form-group>

            <b-form-group :class="{'error-input' : $v.data_master.gelar_depan.$error}">
              <label> Gelar Depan </label>
              <j-input
                v-model="$v.data_master.gelar_depan.$model"
                :disabled="readOnly"
                placeholder="Gelar Depan"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.nik.$error}">
              <label> Nomor Induk Kependudukan </label>
              <j-input
                v-model="$v.data_master.nik.$model"
                :disabled="readOnly"
                placeholder="Nomor Induk Kependudukan"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_master.gelar_belakang.$error}">
              <label> Gelar Belakang </label>
              <j-input
                v-model="$v.data_master.gelar_belakang.$model"
                :disabled="readOnly"
                placeholder="Gelar Belakang"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group :class="{'error-input' : $v.data_master.nama_pegawai.$error}">
          <label> Nama Lengkap </label>
          <j-input
            v-model="$v.data_master.nama_pegawai.$model"
            :disabled="readOnly"
            placeholder="Nama Lengkap"/>
        </b-form-group>
        <b-form-group :class="{'error-input' : $v.data_master.jenis_kelamin.$error}">
          <label> Jenis Kelamin </label>
          <b-form-radio-group
            v-model="$v.data_master.jenis_kelamin.$model"
            :options="list_jenis_kelamin"
            :stacked="true"
            :disabled="readOnly"
            class="jFormGroup"/>
        </b-form-group>
        <b-row>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.tempat_lahir.$error}">
              <label> Tempat Lahir </label>
              <j-input
                v-model="$v.data_master.tempat_lahir.$model"
                :disabled="readOnly"
                placeholder="Tempat Lahir"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.tanggal_lahir.$error}">
              <label> Tanggal Lahir </label>
              <j-datepicker
                v-model="$v.data_master.tanggal_lahir.$model"
                :disabled="readOnly"
                placeholder="Tanggal Lahir"
                format="MMM dd, yyyy"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group :class="{'error-input' : $v.data_master.nama_ibukandung.$error}">
          <label> Nama Ibu Kandung </label>
          <j-input
            v-model="$v.data_master.nama_ibukandung.$model"
            :disabled="readOnly"
            placeholder="Nama Ibu Kandung"/>
        </b-form-group>

        <h4>DATA PRIBADI</h4>
        <b-row>
          <b-col md="6">
            <b-row>
              <b-col md="6">
                <b-form-group :class="{'error-input' : $v.data_master.rt.$error}">
                  <label> RT </label>
                  <j-input
                    v-model="$v.data_master.rt.$model"
                    :disabled="readOnly"
                    placeholder="RT"/>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group :class="{'error-input' : $v.data_master.rw.$error}">
                  <label> RW </label>
                  <j-input
                    v-model="$v.data_master.rw.$model"
                    :disabled="readOnly"
                    placeholder="RW"/>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group :class="{'error-input' : $v.data_master.dusun.$error}">
              <label> Dusun </label>
              <j-input
                v-model="$v.data_master.dusun.$model"
                :disabled="readOnly"
                placeholder="Dusun"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_master.kelurahan_desa.$error}">
              <label> Kelurahan/Desa </label>
              <j-input
                v-model="$v.data_master.kelurahan_desa.$model"
                :disabled="readOnly"
                placeholder="Kelurahan/Desa"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_master.kecamatan.$error}">
              <label> Kecamatan </label>
              <j-input
                v-model="$v.data_master.kecamatan.$model"
                :disabled="readOnly"
                placeholder="Kecamatan"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_master.kabupaten_kota.$error}">
              <label> Kota/Kabupaten </label>
              <j-input
                v-model="$v.data_master.kabupaten_kota.$model"
                :disabled="readOnly"
                placeholder="Kota/Kabupaten"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_master.npwp.$error}">
              <label> NPWP </label>
              <j-input
                v-model="$v.data_master.npwp.$model"
                :disabled="readOnly"
                placeholder="NPWP"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.alamat_rumah.$error}">
              <label> Alamat Lengkap </label>
              <j-textarea
                v-model="$v.data_master.alamat_rumah.$model"
                :disabled="readOnly"
                placeholder="Alamat Lengkap"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_master.kode_pos.$error}">
              <label> Kode POS </label>
              <j-input
                v-model="$v.data_master.kode_pos.$model"
                :disabled="readOnly"
                placeholder="Kode POS"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_master.propinsi.$error}">
              <label> Provinsi </label>
              <j-input
                v-model="$v.data_master.propinsi.$model"
                :disabled="readOnly"
                placeholder="Provinsi"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_master.nama_wajib_pajak.$error}">
              <label> Nama Wajib Pajak </label>
              <j-input
                v-model="$v.data_master.nama_wajib_pajak.$model"
                :disabled="readOnly"
                placeholder="Nama Wajib Pajak"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_master.no_kartu_keluarga.$error}">
              <label> No Kartu Keluarga </label>
              <j-input
                v-model="$v.data_master.no_kartu_keluarga.$model"
                :disabled="readOnly"
                placeholder="No Kartu Keluarga"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group :class="{'error-input' : $v.data_master.agama.$error}">
          <label> Agama </label>
          <j-single-select
            v-model="$v.data_master.agama.$model"
            :options="list_agama"
            :disabled="readOnly"
            placeholder="Pilih Agama"
            label="name"/>
        </b-form-group>
        <b-form-group :class="{'error-input' : $v.data_master.kewarganegaraan.$error}">
          <label> Kewarganegaraan </label>
          <b-form-radio-group
            v-model="$v.data_master.kewarganegaraan.$model"
            :options="list_kewarganegaraan"
            :stacked="true"
            :disabled="readOnly"
            class="jFormGroup"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.status_kawin.$error}">
          <label> Status Perkawinan </label>
          <b-form-radio-group
            v-model="$v.data_master.status_kawin.$model"
            :options="list_status_perkawinan"
            :stacked="true"
            :disabled="readOnly"
            class="jFormGroup"/>
        </b-form-group>

        <h4 class="m__t--15">DATA PASANGAN</h4>
        <b-form-group :class="{'error-input' : $v.data_master.nama_suami_isteri.$error}">
          <label> Nama Suami/Istri </label>
          <j-input
            v-model="$v.data_master.nama_suami_isteri.$model"
            :disabled="readOnly"
            placeholder="Nama Suami/Istri"/>
        </b-form-group>
        <b-row>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.nip_suami_isteri.$error}">
              <label> NIP Suami/Istri </label>
              <j-input
                v-model="$v.data_master.nip_suami_isteri.$model"
                :disabled="readOnly"
                placeholder="NIP Suami/Istri"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.pekerjaan_suami_isteri.$error}">
              <label> Pekerjaan Suami/Istri </label>
              <j-input
                v-model="$v.data_master.pekerjaan_suami_isteri.$model"
                :disabled="readOnly"
                placeholder="Pekerjaan Suami/Istri"/>
            </b-form-group>
          </b-col>
        </b-row>

        <h4>KEPEGAWAIAN</h4>
        <b-row>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.status_kepegawaian.$error}">
              <label> Status </label>
              <j-single-select
                v-model="$v.data_master.status_kepegawaian.$model"
                :options="list_status"
                :disabled="readOnly"
                placeholder="Pilih Status"
                label="name"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_master.niy_nigk.$error}">
              <label> NIY/NIGK </label>
              <j-input
                v-model="$v.data_master.niy_nigk.$model"
                :disabled="readOnly"
                placeholder="NIY/NIGK"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.nip.$error}">
              <label> NIP </label>
              <j-input
                v-model="$v.data_master.nip.$model"
                :disabled="readOnly"
                placeholder="NIP"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_master.nuptk.$error}">
              <label> NUPTK </label>
              <j-input
                v-model="$v.data_master.nuptk.$model"
                :disabled="readOnly"
                placeholder="BUPTK"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group :class="{'error-input' : $v.data_master.jenis_ptk.$error}">
          <label> Jenis PTK </label>
          <j-input
            v-model="$v.data_master.jenis_ptk.$model"
            :disabled="readOnly"
            placeholder="Jenis PTK"/>
        </b-form-group>
        <b-row>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.sk_pengangkatan.$error}">
              <label> SK Pengangkatan </label>
              <j-input
                v-model="$v.data_master.sk_pengangkatan.$model"
                :disabled="readOnly"
                placeholder="SK Pengangkatan"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.tmt_pengangkatan.$error}">
              <label> TMT Pengangkatan </label>
              <j-datepicker
                v-model="$v.data_master.tmt_pengangkatan.$model"
                :disabled="readOnly"
                placeholder="TMT Pengangkatan"
                format="MMM dd, yyyy"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group :class="{'error-input' : $v.data_master.lembaga_pengangkat.$error}">
          <label> Lembaga Pengangkatan </label>
          <j-input
            v-model="$v.data_master.lembaga_pengangkat.$model"
            :disabled="readOnly"
            placeholder="Lembaga Pengangkatan"/>
        </b-form-group>
        <b-row>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.sk_cpns.$error}">
              <label> SK CPNS </label>
              <j-input
                v-model="$v.data_master.sk_cpns.$model"
                :disabled="readOnly"
                placeholder="SK CPNS"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_master.pangkat_gol.$error}">
              <label> Pangkat/Golongan </label>
              <j-input
                v-model="$v.data_master.pangkat_gol.$model"
                :disabled="readOnly"
                placeholder="Pangkat/Golongan"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_master.kartu_pegawai.$error}">
              <label> Kartu Pegawai </label>
              <j-input
                v-model="$v.data_master.kartu_pegawai.$model"
                :disabled="readOnly"
                placeholder="Kartu Pegawai"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.tmt_pns.$error}">
              <label> TMT PNS </label>
              <j-datepicker
                v-model="$v.data_master.tmt_pns.$model"
                :disabled="readOnly"
                placeholder="TMT PNS"
                format="MMM dd, yyyy"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_master.sumber_gaji.$error}">
              <label> Sumber Gaji </label>
              <j-input
                v-model="$v.data_master.sumber_gaji.$model"
                :disabled="readOnly"
                placeholder="Sumber Gaji"/>
            </b-form-group>
            <b-form-group :class="{'error-input' : $v.data_master.kartu_suami_istri.$error}">
              <label> Kartu Istri/Kartu Suami </label>
              <j-input
                v-model="$v.data_master.kartu_suami_istri.$model"
                :disabled="readOnly"
                placeholder="Kartu Istri/Kartu Suami"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="4">
        <b-form-group :class="{'error-input' : $v.data_master.foto.$error}">
          <label> Photo </label><br>
          <j-singleupload
            v-model="$v.data_master.foto.$model"
            :accepted-file-type="['jpg', 'png', 'jpeg']"
            :api-token="token"
            :img-default="$v.data_master.foto.$model"
            :url-upload="url_upload"
            :disabled="readOnly"
            @url="getUrl"/>
          <label v-if="!readOnly">
            Please choose file with supported format file jpg, png, jpeg.
          </label>
        </b-form-group>

        <h4 class="m__t--20">KONTAK</h4>
        <b-form-group :class="{'error-input' : $v.data_master.telp_rumah.$error}">
          <label> No Telepon Rumah </label>
          <j-input
            v-model="$v.data_master.telp_rumah.$model"
            :disabled="readOnly"
            placeholder="No Telepon Rumah"/>
        </b-form-group>
        <b-form-group :class="{'error-input' : $v.data_master.hp.$error}">
          <label> No HP </label>
          <j-input
            v-model="$v.data_master.hp.$model"
            :disabled="readOnly"
            placeholder="No HP"/>
        </b-form-group>
        <b-form-group :class="{'error-input' : $v.data_master.email.$error}">
          <label> Email </label>
          <j-input
            v-model="$v.data_master.email.$model"
            :disabled="readOnly"
            placeholder="Email"/>
        </b-form-group>

        <h4 class="m__t--20">KOMPETENSI KHUSUS</h4>
        <b-form-group :class="{'error-input' : $v.data_master.lisensi_kepsek.$error}">
          <label> Punya Lisensi Kepala Sekolah </label>
          <j-input
            v-model="$v.data_master.lisensi_kepsek.$model"
            :disabled="readOnly"
            placeholder="Punya Lisensi Kepala Sekolah"/>
        </b-form-group>
        <b-form-group :class="{'error-input' : $v.data_master.no_registrasi.$error}">
          <label> No Registrasi </label>
          <j-input
            v-model="$v.data_master.no_registrasi.$model"
            :disabled="readOnly"
            placeholder="No Registrasi"/>
        </b-form-group>
        <b-form-group :class="{'error-input' : $v.data_master.keahlian_laboratorium.$error}">
          <label> Keahlian Laboratorium </label>
          <j-input
            v-model="$v.data_master.keahlian_laboratorium.$model"
            :disabled="readOnly"
            placeholder="Keahlian Laboratorium"/>
        </b-form-group>
        <b-form-group :class="{'error-input' : $v.data_master.keahlian_kebutuhan_khusus.$error}">
          <label> Mampu Menangani Kebutuhan Khusus </label>
          <j-single-select
            v-model="$v.data_master.keahlian_kebutuhan_khusus.$model"
            :options="list_kebutuhan_khusus"
            :disabled="readOnly"
            placeholder="Mampu Menangani Kebutuhan Khusus"
            label="name"/>
        </b-form-group>
        <b-form-group :class="{'error-input' : $v.data_master.keahlian_braile.$error}">
          <label> Keahlian Braile </label>
          <b-form-radio-group
            v-model="$v.data_master.keahlian_braile.$model"
            :options="list_yes_no"
            :stacked="true"
            :disabled="readOnly"
            class="jFormGroup"/>
        </b-form-group>
        <b-form-group :class="{'error-input' : $v.data_master.keahlian_bahasa_isyarat.$error}">
          <label> Keahlian Bahasa Isyarat </label>
          <b-form-radio-group
            v-model="$v.data_master.keahlian_bahasa_isyarat.$model"
            :options="list_yes_no"
            :stacked="true"
            :disabled="readOnly"
            class="jFormGroup"/>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="6">
        <!-- <b-button
          v-if="!$route.params.module"
          class="btn red m__t--20"
          @click="deleteData">
          Delete
        </b-button> -->
      </b-col>
      <b-col md="6">
        <div class="float-to-right m__t--20">
          <b-button
            v-if="!readOnly"
            class="btn blue m__r--5"
            @click="saveData">
            Update
          </b-button>
          <b-button
            class="btn gray"
            @click="$router.replace('/kepegawaian')">
            Cancel
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len, no-nested-ternary */
import { mapActions, mapState } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

export default {
  // eslint-disable-next-line
  name: 'jGeneral',
  components: {
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      data_master: {
        id: this.$route.params.id,
        kode_pegawai: '',
        foto: null,

        nama_pegawai: '',
        gelar_depan: '',
        gelar_belakang: '',
        nik: '',
        jenis_kelamin: null,
        tempat_lahir: '',
        tanggal_lahir: null,
        nama_ibukandung: '',

        alamat_rumah: '',
        rt: '',
        rw: '',
        dusun: '',
        kelurahan_desa: '',
        kecamatan: '',
        kabupaten_kota: '',
        no_kartu_keluarga: '',
        kode_pos: '',
        propinsi: '',
        agama: null,
        npwp: '',
        nama_wajib_pajak: '',
        kewarganegaraan: null,
        status_kawin: null,
        nama_suami_isteri: '',
        nip_suami_isteri: '',
        pekerjaan_suami_isteri: '',

        status_kepegawaian: null,
        nip: '',
        niy_nigk: '',
        nuptk: '',
        jenis_ptk: '',
        sk_pengangkatan: '',
        tmt_pengangkatan: null,
        lembaga_pengangkat: '',
        sk_cpns: '',
        tmt_pns: null,
        pangkat_gol: '',
        sumber_gaji: '',
        kartu_pegawai: '',
        kartu_suami_istri: '',

        lisensi_kepsek: '',
        no_registrasi: '',
        keahlian_laboratorium: '',
        keahlian_kebutuhan_khusus: null,
        keahlian_braile: null,
        keahlian_bahasa_isyarat: null,

        telp_rumah: '',
        hp: '',
        email: '',
      },
      list_jenis_kelamin: [
        {
          value: 'L',
          text: 'Laki-Laki',
        },
        {
          value: 'P',
          text: 'Perempuan',
        },
      ],
      list_agama: [
        {
          id: 1,
          name: 'Islam',
        },
        {
          id: 2,
          name: 'Kristen/Protestan',
        },
        {
          id: 3,
          name: 'Hindu',
        },
        {
          id: 4,
          name: 'Budha',
        },
        {
          id: 5,
          name: 'Kong Hu Chu',
        },
        {
          id: 6,
          name: 'Lainnya',
        },
      ],
      list_kewarganegaraan: [
        {
          value: 'Indonesia',
          text: 'Indonesia (WNI)',
        },
        {
          value: 'Asing',
          text: 'Asing (WNA)',
        },
      ],
      list_status_perkawinan: [
        {
          value: 1,
          text: 'Kawin',
        },
        {
          value: 2,
          text: 'Belum Kawin',
        },
        {
          value: 3,
          text: 'Janda/Duda',
        },
      ],
      list_status: [
        {
          id: 'PNS',
          name: 'PNS',
        },
        {
          id: 'PNS Diperbantukan',
          name: 'PNS Diperbantukan',
        },
        {
          id: 'PNS Depag',
          name: 'PNS Depag',
        },
        {
          id: 'GTY/PTY',
          name: 'GTY/PTY',
        },
        {
          id: 'GTT/PTT Provinsi',
          name: 'GTT/PTT Provinsi',
        },
        {
          id: 'GTT/PTT Kab/Kota',
          name: 'GTT/PTT Kab/Kota',
        },
        {
          id: 'Guru Bantu Pusat',
          name: 'Guru Bantu Pusat',
        },
        {
          id: 'Guru Honor Sekolah',
          name: 'Guru Honor Sekolah',
        },
        {
          id: 'Tenaga Honor',
          name: 'Tenaga Honor',
        },
        {
          id: 'CPNS',
          name: 'CPNS',
        },
        {
          id: 'Aktif',
          name: 'Aktif',
        },
        {
          id: 'Pensiun',
          name: 'Pensiun',
        },
        {
          id: 'Pindah',
          name: 'Pindah',
        },
        {
          id: 'Keluar',
          name: 'Keluar',
        },
      ],
      list_yes_no: [
        {
          value: 'Ya',
          text: 'Ya',
        },
        {
          value: 'Tidak',
          text: 'Tidak',
        },
      ],
      list_kebutuhan_khusus: [
        {
          id: 'tidak',
          name: 'Tidak',
        },
        {
          id: 'netra',
          name: 'Netra',
        },
        {
          id: 'rungu',
          name: 'Rungu',
        },
        {
          id: 'grahita ringan',
          name: 'Grahita Ringan',
        },
        {
          id: 'grahita sedang',
          name: 'Grahita Sedang',
        },
        {
          id: 'daksa ringan',
          name: 'Daksa Ringan',
        },
        {
          id: 'daksa sedang',
          name: 'Daksa Sedang',
        },
        {
          id: 'laras',
          name: 'Laras',
        },
        {
          id: 'wicara',
          name: 'Wicara',
        },
        {
          id: 'tuna ganda',
          name: 'Tuna Ganda',
        },
        {
          id: 'hyper aktif',
          name: 'Hyper Aktif',
        },
        {
          id: 'cerdas istimewa',
          name: 'Cerdas Istimewa',
        },
        {
          id: 'bakat istimewa',
          name: 'Bakat Istimewa',
        },
        {
          id: 'kesulitan belajar',
          name: 'Kesulitan Belajar',
        },
        {
          id: 'narkoba',
          name: 'Narkoba',
        },
        {
          id: 'indigo',
          name: 'Indigo',
        },
        {
          id: 'down sindrome',
          name: 'Down Sindrome',
        },
        {
          id: 'autis',
          name: 'Autis',
        },
      ],
      token: (JSON.parse(localStorage.getItem('Token'))).value,
    };
  },
  computed: {
    url_upload() {
      return `${process.env.GATE_URL}file/upload`;
    },
  },
  watch: {
  },
  created() {
    const param = { id: this.$route.params.id };
    this.detailPegawai(param).then((res) => {
      const dataDetail = res.data.data[0];

      this.data_master.kode_pegawai = dataDetail.kode_pegawai ? dataDetail.kode_pegawai : '';
      this.data_master.foto = dataDetail.foto ? dataDetail.foto : null;

      this.data_master.nama_pegawai = dataDetail.nama_pegawai ? dataDetail.nama_pegawai : '';
      this.data_master.gelar_depan = dataDetail.gelar_depan ? dataDetail.gelar_depan : '';
      this.data_master.gelar_belakang = dataDetail.gelar_belakang ? dataDetail.gelar_belakang : '';
      this.data_master.nik = dataDetail.nik ? dataDetail.nik : '';
      this.data_master.jenis_kelamin = dataDetail.jenis_kelamin ? dataDetail.jenis_kelamin : null;
      this.data_master.tempat_lahir = dataDetail.tempat_lahir ? dataDetail.tempat_lahir : '';
      this.data_master.tanggal_lahir = dataDetail.tanggal_lahir ? dataDetail.tanggal_lahir : null;
      this.data_master.nama_ibukandung = dataDetail.nama_ibukandung ? dataDetail.nama_ibukandung : '';

      this.data_master.alamat_rumah = dataDetail.alamat_rumah ? dataDetail.alamat_rumah : '';
      this.data_master.rt = dataDetail.rt ? dataDetail.rt : '';
      this.data_master.rw = dataDetail.rw ? dataDetail.rw : '';
      this.data_master.dusun = dataDetail.dusun ? dataDetail.dusun : '';
      this.data_master.kelurahan_desa = dataDetail.kelurahan_desa ? dataDetail.kelurahan_desa : '';
      this.data_master.kecamatan = dataDetail.kecamatan ? dataDetail.kecamatan : '';
      this.data_master.kabupaten_kota = dataDetail.kabupaten_kota ? dataDetail.kabupaten_kota : '';
      this.data_master.no_kartu_keluarga = dataDetail.no_kartu_keluarga ? dataDetail.no_kartu_keluarga : '';
      this.data_master.kode_pos = dataDetail.kode_pos ? dataDetail.kode_pos : '';
      this.data_master.propinsi = dataDetail.propinsi ? dataDetail.propinsi : '';
      this.data_master.agama = dataDetail.agama ? (dataDetail.agama === '0' ? null : dataDetail.agama) : null;
      this.data_master.npwp = dataDetail.npwp ? dataDetail.npwp : '';
      this.data_master.nama_wajib_pajak = dataDetail.nama_wajib_pajak ? dataDetail.nama_wajib_pajak : '';
      this.data_master.kewarganegaraan = dataDetail.kewarganegaraan ? dataDetail.kewarganegaraan : null;
      this.data_master.status_kawin = dataDetail.status_kawin ? dataDetail.status_kawin : null;
      this.data_master.nama_suami_isteri = dataDetail.nama_suami_isteri ? dataDetail.nama_suami_isteri : '';
      this.data_master.nip_suami_isteri = dataDetail.nip_suami_isteri ? dataDetail.nip_suami_isteri : '';
      this.data_master.pekerjaan_suami_isteri = dataDetail.pekerjaan_suami_isteri ? dataDetail.pekerjaan_suami_isteri : '';

      this.data_master.status_kepegawaian = dataDetail.status_kepegawaian ? dataDetail.status_kepegawaian : null;
      this.data_master.nip = dataDetail.nip ? dataDetail.nip : '';
      this.data_master.niy_nigk = dataDetail.niy_nigk ? dataDetail.niy_nigk : '';
      this.data_master.nuptk = dataDetail.nuptk ? dataDetail.nuptk : '';
      this.data_master.jenis_ptk = dataDetail.jenis_ptk ? dataDetail.jenis_ptk : '';
      this.data_master.sk_pengangkatan = dataDetail.sk_pengangkatan ? dataDetail.sk_pengangkatan : '';
      this.data_master.tmt_pengangkatan = dataDetail.tmt_pengangkatan ? dataDetail.tmt_pengangkatan : null;
      this.data_master.lembaga_pengangkat = dataDetail.lembaga_pengangkat ? dataDetail.lembaga_pengangkat : '';
      this.data_master.sk_cpns = dataDetail.sk_cpns ? dataDetail.sk_cpns : '';
      this.data_master.tmt_pns = dataDetail.tmt_pns ? dataDetail.tmt_pns : null;
      this.data_master.pangkat_gol = dataDetail.pangkat_gol ? dataDetail.pangkat_gol : '';
      this.data_master.sumber_gaji = dataDetail.sumber_gaji ? dataDetail.sumber_gaji : '';
      this.data_master.kartu_pegawai = dataDetail.kartu_pegawai ? dataDetail.kartu_pegawai : '';
      this.data_master.kartu_suami_istri = dataDetail.kartu_suami_istri ? dataDetail.kartu_suami_istri : '';

      this.data_master.lisensi_kepsek = dataDetail.lisensi_kepsek ? dataDetail.lisensi_kepsek : '';
      this.data_master.no_registrasi = dataDetail.no_registrasi ? dataDetail.no_registrasi : '';
      this.data_master.keahlian_laboratorium = dataDetail.keahlian_laboratorium ? dataDetail.keahlian_laboratorium : '';
      this.data_master.keahlian_kebutuhan_khusus = dataDetail.keahlian_kebutuhan_khusus ? dataDetail.keahlian_kebutuhan_khusus : null;
      this.data_master.keahlian_braile = dataDetail.keahlian_braile ? dataDetail.keahlian_braile : null;
      this.data_master.keahlian_bahasa_isyarat = dataDetail.keahlian_bahasa_isyarat ? dataDetail.keahlian_bahasa_isyarat : null;

      this.data_master.telp_rumah = dataDetail.telp_rumah ? dataDetail.telp_rumah : '';
      this.data_master.hp = dataDetail.hp ? dataDetail.hp : '';
      this.data_master.email = dataDetail.email ? dataDetail.email : '';
    });
  },
  methods: {
    ...mapActions('jStoreKurikulum', ['detailPegawai', 'updatePegawai', 'deletePegawai']),

    getUrl(data) {
      this.data_master.foto = data;
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.updatePegawai(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              if (this.$route.params.module) {
                this.$router.push('/home');
              } else {
                this.$router.push('/kepegawaian');
              }
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.$route.params.id,
          };
          this.deletePegawai(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$router.push('/kepegawaian');
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        kode_pegawai: { required },
        foto: { required },

        nama_pegawai: { required },
        gelar_depan: {},
        gelar_belakang: {},
        nik: { required },
        jenis_kelamin: { required },
        tempat_lahir: { required },
        tanggal_lahir: { required },
        nama_ibukandung: { required },

        alamat_rumah: {},
        rt: {},
        rw: {},
        dusun: {},
        kelurahan_desa: {},
        kecamatan: {},
        kabupaten_kota: {},
        no_kartu_keluarga: {},
        kode_pos: {},
        propinsi: {},
        agama: {},
        npwp: {},
        nama_wajib_pajak: {},
        kewarganegaraan: {},
        status_kawin: {},
        nama_suami_isteri: {},
        nip_suami_isteri: {},
        pekerjaan_suami_isteri: {},
        status_kepegawaian: {},
        nip: {},
        niy_nigk: {},
        nuptk: {},
        jenis_ptk: {},
        sk_pengangkatan: {},
        tmt_pengangkatan: {},
        lembaga_pengangkat: {},
        sk_cpns: {},
        tmt_pns: {},
        pangkat_gol: {},
        sumber_gaji: {},
        kartu_pegawai: {},
        kartu_suami_istri: {},

        lisensi_kepsek: {},
        no_registrasi: {},
        keahlian_laboratorium: {},
        keahlian_kebutuhan_khusus: {},
        keahlian_braile: {},
        keahlian_bahasa_isyarat: {},

        telp_rumah: {},
        hp: {},
        email: {},
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/tab-component/jGeneral.vue